<template>
  <div v-if="item" class="text-left">
    <div class="h3">
      <div class="d-flex align-items-center">
        <span class="text-uppercase">{{ item.get('or_id') }}</span>
        <StatusTag :status="item.get('status')" />
      </div>
    </div>
    <el-divider />
    <OrderCustomerCard
      class="mb-3"
      :customer="user"
      :delivery-address="deliveryAddress"
      :delivery-date="deliveryDate"
    />
    <OrderInformationCard class="mb-3" :information="information" />
    <OrderCartCard class="mb-3" :products="products" :systems="systems" />
    <div v-if="false" class="d-flex justify-content-end">
      <el-button type="primary" @click="onChangeStatusOfOrder('confirmed')">
        Bestätigen
      </el-button>
      <el-button type="success" @click="onChangeStatusOfOrder('done')">
        Erledigt
      </el-button>
      <el-button type="danger" @click="onChangeStatusOfOrder('rejected')">
        Stornieren
      </el-button>
    </div>
  </div>
</template>

<script>
import User from '../../../api/dto/User';
import DeliveryAddress from '../../../api/dto/DeliveryAddress';
import OrderCustomerCard from './components/OrderCustomerCard';
import OrderInformationCard from './components/OrderInformationCard';
import OrderCartCard from './components/OrderCartCard';
import StatusTag from '../../../components/atoms/StatusTag';

export default {
  name: 'DetailOrderRequestView',
  components: { StatusTag, OrderCartCard, OrderInformationCard, OrderCustomerCard },
  props: {
    table: String,
    canModify: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    await this.onLoad();
  },
  destroyed() {},
  data() {
    return {
      item: null,
      user: {},
      deliveryAddress: {},
      systems: [],
      products: [],
      activeCards: ['1', '2', '3', '4', '5'],
      information: {
        notes: '',
        lkw: false,
        contactAtLocation: '',
      },
      deliveryDate: '',
      error: null,
    };
  },
  computed: {
    customerHeaderTitle() {
      return this.isOrders ? this.$t('general.customer') : this.$t('general.interestedParty');
    },

    siteHeaderTitle() {
      return this.isOrders ? this.$t('general.orders') : this.$t('general.requests');
    },
    isOrders() {
      return this.table === 'CartOrder';
    },
  },
  methods: {
    async onLoad() {
      let query = new this.$parse.Query(this.table);
      query.includeAll();
      this.item = await query.get(this.$route.params.id);

      this.user = new User(this.item.get('user'));
      this.deliveryAddress = new DeliveryAddress(this.item.get('deliveryAddress'));
      this.systems = this.item.get('systems');
      this.products = this.item.get('products');
      this.information.contactAtLocation = this.item.get('contactAtLocation');
      this.information.lkw = this.item.get('lkw');
      this.information.project = this.item.get('project');
      this.deliveryDate = this.getDate(this.item.get('deliveryDate'));
    },
    getUserName() {
      let user = this.item.get('user');
      return user.get('firstname') + ', ' + user.get('lastname') + '(' + user.get('company') + ')';
    },
    getDate(date) {
      let d = new Date(date);
      return d.toLocaleDateString(this.$locale);
    },
    async onChangeStatusOfOrder(status) {
      let response = await this.$parse.Cloud.run(
        'changeStatusOfOrderRequest',
        { id: this.item.id, className: this.table, status: status },
        {}
      );
      await this.onLoad();
      this.$message.info(response.message);
    },
  },
};
</script>

<style lang="scss" scoped>
.register-card {
  max-width: 600px;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(15px);
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-top: 0 !important;
  width: 95%;
}
.register-logo {
  max-width: 300px;
  margin: 0 auto;
}
</style>
